import { useLocation } from "react-router-dom";

import { ToastContainer } from "react-toastify";

// The student elevation's shared primitive layer (F01). Imported here, once,
// because every routed page renders inside Layout; it lands in the main
// stylesheet instead of being duplicated into each lazy route chunk. Every
// selector in it is an opt-in `xe-` class, so nothing changes on a page that
// does not use one (admin, teacher and credential pages included).
import "../experienceElevation/presentation.css";
import { FacilitatorContextProvider } from "../FacilitatorShell/FacilitatorContextProvider";
import AdminSidebar from "./AdminSidebar";
import { ExperienceContextOwner } from "./ExperienceContext";
import Sidebar from "./Sidebar";

export const Layout = ({
  children,
  facilitatorUserId = null,
  facilitatorRoleId = null,
}) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const isAuthPage =
    location.pathname === "/login" || location.pathname === "/register";
  // v4.0 F7: the cinematic kickoff is a full-screen surface that cannot
  // sit inside the Sidebar layout. Match any path like
  // /challenges/<id>/kickoff and suppress chrome the same way auth pages do.
  // The kickoff fetches its own status and renders fail-closed retry UI on
  // its own; it does not need ToastContainer or the global navigation.
  const isKickoffPage = /^\/challenges\/[^/]+\/kickoff(?:\/.*)?$/.test(
    location.pathname,
  );
  // M2: the one delivery-context discovery for every student route,
  // kickoff included (it posts the active cohort). Staff (role 4, the same
  // test App uses for isAdmin) and signed-out sessions never discover. The
  // signed-in user's id and role arrive as the props App already passes.
  const discoveryEnabled =
    facilitatorUserId !== null &&
    facilitatorUserId !== undefined &&
    Number(facilitatorRoleId) !== 4 &&
    !isAdminRoute;

  if (isAuthPage || isKickoffPage) {
    return (
      <>
        <ToastContainer className="w-auto" />
        {isKickoffPage ? (
          <ExperienceContextOwner
            enabled={discoveryEnabled}
            userId={facilitatorUserId}
          />
        ) : null}
        {children}
      </>
    );
  }

  if (isAdminRoute) {
    // THE PROVIDER MOUNTS HERE, once, OUTSIDE <Routes>. That placement is the
    // whole point: navigating between the four surfaces re-renders the routed
    // child but leaves this provider mounted, so the glance poll is not
    // restarted and the freshness stamp does not reset every time a facilitator
    // moves from coach to review and back.
    return (
      <>
        <ToastContainer className="w-auto" />
        <FacilitatorContextProvider
          privacyUserId={facilitatorUserId}
          facilitatorRoleId={facilitatorRoleId}
        >
          <AdminSidebar>{children}</AdminSidebar>
        </FacilitatorContextProvider>
      </>
    );
  }

  return (
    <>
      <ToastContainer className="w-auto" />
      <ExperienceContextOwner
        enabled={discoveryEnabled}
        userId={facilitatorUserId}
      />
      <Sidebar>{children}</Sidebar>
    </>
  );
};
